import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { getCountry } from "../../../Slice/country.slice";
import { getBillHeaderId } from "../../../Slice/orderBillList.slice";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { ClaimTypeJson } from "../../../DynamicFormsJson/MastersJSON/claimType";

class ClaimTypeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: ClaimTypeJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Name",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Short Name",
                  value:
                    data.data !== null && data.data.shortName !== null
                      ? data.data.shortName
                      : "",
                },

                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Type",
                  value:
                    data.data !== null && data.data.type !== null
                      ? data.data.type == 0
                        ? "Per-UOM"
                        : data.data.type == 1
                        ? "Custom"
                        : data.data.type == 2
                        ? "Limit"
                        : data.data.type == 3
                        ? "Daily Allowance"
                        : "Travel Allowance"
                      : "",
                },

                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Type",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup value={data.data.type} row name="type">
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="Per-UOM"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Custom"
                //           />
                //           <FormControlLabel
                //             value="2"
                //             control={<Radio disabled />}
                //             label="Limit"
                //           />
                //           <FormControlLabel
                //             value="3"
                //             control={<Radio disabled />}
                //             label="Daily Allowance"
                //           />
                //           <FormControlLabel
                //             value="4"
                //             control={<Radio disabled />}
                //             label="Travel Allowance"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },

                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Attachment Applicable",
                  value:
                    data.data !== null &&
                    data.data.attachmentApplicable !== null
                      ? data.data.attachmentApplicable == 0
                        ? "Yes"
                        : "No"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Attachment Applicable",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup
                //           value={data.data.attachmentApplicable}
                //           row
                //           name="attachmentApplicable"
                //         >
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="Yes"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="No"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Remark",
                  value:
                    data.data !== null && data.data.remark !== null
                      ? data.data.remark
                      : "",
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Claim Type View"}
            fieldMeta={[]}
            apiBaseURL={ClaimTypeJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getBillHeaderId,
  getCountry,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ClaimTypeView);
